import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './guards/auth.guard';
import { LoginComponent } from './components/login/login.component';
import { UserListComponent } from './components/users/user-list/user-list.component';
import { UserProfileComponent } from './components/users/user-profile/user-profile.component';
import { UserProfileIntercomRedirectComponent } from './components/users/user-profile-intercom-redirect/user-profile-intercom-redirect.component';
import { OrdersComponent } from './components/orders/orders.component';
import { OrderDetailsComponent } from './components/orders/order-details/order-details.component';
import { ArticleFamilyComponent } from './components/article/article-family/article-family.component';
import { ArticleSettingComponent } from './components/article/article-setting/article-setting.component';
import { ArticleListComponent } from './components/article/article-list/article-list.component';
import { NewArticleComponent } from './components/article/new-article/new-article.component';
import { ArticlePricesComponent } from './components/article/article-prices/article-prices.component';
import { ArticleDetailsComponent } from './components/article/article-details/article-details.component';
import { ArticlePackListComponent } from './components/article/article-pack-list/article-pack-list.component';
import { ArticlePackEditComponent } from './components/article/article-pack-edit/article-pack-edit.component';
import { LavandierListComponent } from './components/lavandier/lavandier-list/lavandier-list.component';
import { LavandierDetailsComponent } from './components/lavandier/lavandier-details/lavandier-details.component';
import { NewLavandierComponent } from './components/lavandier/new-lavandier/new-lavandier.component';
import { UserTypeSettingComponent } from './components/lavoirmoderne/user-type-setting/user-type-setting.component';
import { UserTypeEditComponent } from './components/lavoirmoderne/user-type-edit/user-type-edit.component';
import { DiscountCodeListComponent } from './components/users/discount-code-list/discount-code-list.component';
import { DiscountCodeAddComponent } from './components/users/discount-code-add/discount-code-add.component';
import { RoleListComponent } from './components/lavandier/role-list/role-list.component';
import { RoleDetailsComponent } from './components/lavandier/role-details/role-details.component';
import { RoleAddComponent } from './components/lavandier/role-add/role-add.component';
import { RoleGuard } from './role.guard';
import { PermissionName } from '../lib/lib-shared/types/PermissionName';
import { CalendarComponent } from './components/store/calendar/calendar.component';
import { EditAccountComponent } from './components/account/edit-account/edit-account.component';
import { EditUserComponent } from './components/user/edit-user/edit-user.component';
import { OrderShipReturnListComponent } from './components/order/order-ship-return-list/order-ship-return-list.component';
import { PtlComponent } from './components/ptl/ptl.component';

const routes: Routes = [
  {
    path: 'account/new/:userTypeId',
    component: EditAccountComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'account/edit/:id',
    component: EditAccountComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'user/new',
    component: EditUserComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'user/edit/:id',
    component: EditUserComponent,
    canActivate: [AuthGuard]
  },
  /**** clean is done below this comment ****/
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'lavandier/list',
    component: LavandierListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'lavandier/details/:id',
    component: LavandierDetailsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'lavandier/add',
    component: NewLavandierComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'calendar',
    component: CalendarComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'user/list',
    component: UserListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'user-profile/:id',
    component: UserProfileComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'user-profile/:id/intercom',
    component: UserProfileIntercomRedirectComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'orders',
    component: OrdersComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'order-details/:id',
    component: OrderDetailsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'ordershipreturn/list',
    component: OrderShipReturnListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'ptl',
    component: PtlComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'article/setting',
    component: ArticleSettingComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'article/family',
    component: ArticleFamilyComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'article/list',
    component: ArticleListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'article/add',
    component: NewArticleComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'article/edit/:id',
    component: NewArticleComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'article-pack/list',
    component: ArticlePackListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'article-pack/add',
    component: ArticlePackEditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'article-pack/edit/:id',
    component: ArticlePackEditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'article/prices/:id',
    component: ArticlePricesComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'article/details/:id',
    component: ArticleDetailsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'user-type-setting',
    component: UserTypeSettingComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'user-type-setting/edit/:userTypeId',
    component: UserTypeEditComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'discount-code/list',
    component: DiscountCodeListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'discount-code/add',
    component: DiscountCodeAddComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'role/list',
    component: RoleListComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: {permissionNameList: [PermissionName.ROLE_LIST]},
  },
  {
    path: 'role/details/:id',
    component: RoleDetailsComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: {permissionNameList: [PermissionName.ROLE_VIEW]},
  },
  {
    path: 'role/add',
    component: RoleAddComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: {permissionNameList: [PermissionName.ROLE_CREATE]},
  },
  {
    path: '**',
    redirectTo: 'orders'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
